// extracted by mini-css-extract-plugin
module.exports = {"segments":"Segments_segments__9v0jL","segment":"Segments_segment__1NgUj","icon":"Segments_icon__3nteG","active":"Segments_active__1R0DH","small":"Segments_small__1eZD0"};